<template>
<div>
  <span>Nouvelle donnée </span>
</div>
</template>

<script>
export default {
  name: "NewData"
}
</script>

<style scoped>

</style>